module.exports = __webpack_public_path__ + "img/flag_en.a68cebe0.svg";